$( document ).ready(function() {
  $('.custom-show-more-height-checker').each(function() {
      var content = $(this).height();
      if(content > 51){
        $(this).addClass("show-more-height");
      }else{
        var data_index = $(this).attr('data-iddex');
        $('.show-more-'+data_index).hide();
      }
  });
  $(".show-more").click(function () {
    var count_data = $(this).attr("data-id");
    if($(".text-"+count_data).hasClass("show-more-height")) {
      $(this).text("Read less");
    }
    else {
      $(this).text("Read more");
    }
    $(".text-"+count_data).toggleClass("show-more-height");
  });
});